<template>
<div>
    <vue-headful title="Photos" />

    <v-container fluid>
        <v-row no-gutters class="mt-3">
            <!-- place filter-->
            <v-col cols="6" md="3" class="px-1">
                <v-card class="elevation-1 pa-1">
                    <div class="detail font-weight-bold pa-0 ma-0">Place</div>
                    <im-place-search class="im-select ma-0" placeholder="Any ..." @input="filterLocation($event)" hide-details />
                </v-card>
            </v-col>
            <!--./ place filter-->
            <!-- section filter-->
            <v-col cols="6" md="3" class="px-1">
                <v-card class="elevation-1 pa-1">
                    <div class="detail font-weight-bold pa-0 ma-0">Section</div>
                    <v-select class="im-select pa-0 ma-0" :items="sections" v-model="filter_section_id" item-text="title.ro" item-value="id" flat solo clearable placeholder="Any ..." @input="filterItems()" />
                </v-card>
            </v-col>
            <!--./ section filter-->
            <!-- user filter-->
            <v-col cols="6" md="3" class="px-1">
                <v-card class="elevation-1 pa-1">
                    <div class="detail font-weight-bold pa-0 ma-0">User</div>
                    <im-user-search class="im-select ma-0" placeholder="Type here to select ..." @input="filterUser($event)" hide-details />
                </v-card>
            </v-col>
            <!--./ user filter-->
            <!-- status filter-->
            <v-col cols="6" md="3" class="px-1">
                <v-card class="elevation-1 pa-1">
                    <div class="detail font-weight-bold pa-0 ma-0">Status</div>
                    <v-select class="im-select pa-0 ma-0" flat solo v-model="status" :items="status_items" item-text="text" item-value="value" placeholder="Any" clearable :menu-props="{transition:'scale-transition', 'offset-y': ''}" @input="filterItems()"
                        hide-details />
                </v-card>
            </v-col>
            <!--./ status filter-->
        </v-row>

        <!-- SEARCH -->
        <div class="im-search mt-3 mb-1">
            <div class="d-flex">
                <v-text-field class="ma-0 mx-1 white pt-0" flat v-model="search" clearable placeholder="Type here to search by field ..." append-icon="search" hide-details></v-text-field>
                <v-icon medium class="px-1" @click="dialog_mobile_sort=true">swap_vert
                </v-icon>
            </div>
            <div class="d-flex mx-1 py-2 fields align-center">
                <span class="detail mr-1 hidden-sm-and-down">Find in:</span>
                <v-btn class="mx-1 detail" v-for="field in search_fields" :key="field.value" small rounded depressed :color="field.selected ? 'primary' : 'grey lighten-2'" :text-color="field.selected ? 'white' : 'grey'" @click="selectField(field)">
                    <span class="text-capitalize">{{field.text}}</span>
                </v-btn>
            </div>
        </div>
        <!-- ./ SEARCH -->

        <!--./ data table -->
        <div class="mx-1" style="position: relative; height: 3px">
            <v-progress-linear v-if="loading" indeterminate height="3" class="pa-0 ma-0" color="primary" style="position: absolute" />
        </div>

        <!-- DATATABLE ROWS -->
        <v-data-iterator :items="items" :page.sync="page" :items-per-page.sync="size" :server-items-length="total" :footer-props="{ itemsPerPageOptions }">
            <template v-slot:default="props">
                <v-row no-gutters>
                    <v-col v-for="item in props.items" cols="12" sm="6" md="4" lg="3" :key="item.id">
                        <im-photo-item :item="item" @click.native="seeItem(item)" />
                    </v-col>
                </v-row>
            </template>
            <template v-slot:no-data>
                <v-alert :value="true" type="info" color="primary">
                    No data available.
                </v-alert>
            </template>
        </v-data-iterator>

    </v-container>

    <!-- add button -->
    <v-btn color="primary" @click="openCreate()" large fab fixed bottom right>
        <v-icon>add</v-icon>
    </v-btn>
    <!-- ./ add button -->

    <!-- place modal dialog -->
    <v-dialog v-model="dialog_photo" max-width="850px" :fullscreen="$vuetify.breakpoint.smAndDown" persistent :overlay="false" transition="dialog-transition">
        <v-card>
            <v-card flat tile>
                <v-card-title class="headline p-2">
                    Photo Details
                    <v-spacer />
                    <v-btn icon left @click="dialog_photo=false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>
            </v-card>
            <im-photo-modal :item="current_photo" />
            <v-card-actions>
                <v-btn color="red" @click="openDeleteModal(current_photo)">Delete</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="openEdit(current_photo)">Edit</v-btn>
                <v-btn color="primary" text @click="dialog_photo = false">Cancel</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- place modal dialog -->
    <!-- add dialog  -->
    <v-dialog v-model="add_dialog" max-width="920" :fullscreen="$vuetify.breakpoint.smAndDown">
        <v-card flat tile color="primary">
            <v-card-title class="important white--text" height="50">
                Photo
            </v-card-title>
            <v-container fluid style="background-color: #f5f5f5;" :class="{ 'px-0': $vuetify.breakpoint.smAndDown, 'pt-3': true}">
                <v-row no-gutters>
                    <v-col cols="12" md="6" class="pa-2">
                        <v-img v-if="images[0]" :src="images[0]" height="280px" contain />
                        <v-img v-else-if="photo.url" :src="photo.url" height="280px" contain />
                        <v-img v-else height="280px" style="outline: 1px dotted; cursor: pointer;">
                            <v-card flat height="280px">
                                <div class="text-center" style="text-align: center">
                                    <input type="file" ref="fileInput" accept="image/*" @change="onFileChanged" class="input-file">
                                    Drag your file here to begin<br> or click to browse
                                </div>
                            </v-card>
                        </v-img>
                    </v-col>
                    <v-col cols="12" md="6" class="pa-2">
                        <v-card class="elevation-1 pa-2">
                            <div class="detail font-weight-bold pa-0 ma-0">Place</div>
                            <im-place-search class="im-select ma-0" :place="photo.place" ref="place" placeholder="Any ..." @input="selectPlace($event)" hide-details />
                        </v-card>
                        <v-card class="elevation-1 my-2 pa-2">
                            <div class="detail font-weight-bold pa-0 ma-0">Section</div>
                            <v-select class="im-select pa-0 ma-0" :items="sections" v-model="photo.section_id" item-text="title.ro" item-value="id" flat solo clearable placeholder="Select section" />
                        </v-card>
                        <v-card class="elevation-1 my-2 pa-2">
                            <div class="detail font-weight-bold pa-0 ma-0">Title</div>
                            <v-text-field v-model="photo.title" class="im-select ma-0" solo flat clearable placeholder="Enter the title for photo" hide-details />
                        </v-card>
                        <v-card class="elevation-1 my-2 pa-2">
                            <div class="detail font-weight-bold pa-0 ma-0">Description</div>
                            <v-text-field v-model="photo.description" class="im-select ma-0" solo flat clearable placeholder="Enter a description for " hide-details />
                        </v-card>
                        <v-card class="elevation-1 my-2 pa-2">
                            <div class="detail font-weight-bold pa-0 ma-0">Status</div>
                            <v-select class="im-select pa-0 ma-0" flat solo v-model="photo.status" :items="status_items" item-text="text" item-value="value" placeholder="Any" clearable :menu-props="{transition:'scale-transition', 'offset-y': ''}"
                                hide-details />
                        </v-card>
                        <v-card class="elevation-1 my-2 pa-2">
                            <div class="detail font-weight-bold pa-0 ma-0">Order</div>
                            <v-text-field v-model="photo.order" class="im-select ma-0" solo flat clearable placeholder="Enter the order for photo" hide-details />
                        </v-card>
                    </v-col>
                </v-row>
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" text @click="add_dialog=false">Cancel</v-btn>
                    <v-btn color="primary" :loading="is_saving" :disabled="is_saving" @click="savePhoto()">Submit</v-btn>
                </v-card-actions>
            </v-container>
        </v-card>
    </v-dialog>
    <!--./ add dialog  -->
    <!-- dialog mobile sort -->
    <v-dialog v-model="dialog_mobile_sort" max-width="300px">
        <v-card>
            <v-card-text class="important">
                Sort Items by
            </v-card-text>
            <im-sort-filed :items="im_header" @clickSort="sortField($event)"></im-sort-filed>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="dialog_mobile_sort = false">
                    Cancel
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- ./ dialog dialog mobile sort -->
    <!--delete dialog-->
    <v-dialog v-model="delete_dialog" max-width="320">
        <v-card>
            <v-card-text>
                Are you sure you want to delete this photo?
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn dark color="red" :loading="loading_delete" @click="destroy()">
                    Delete
                </v-btn>
                <v-btn color="primary" text @click="delete_dialog=false">
                    Cancel
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!--./delete dialog -->
</div>
</template>
<script>
import {
    mapActions
} from 'vuex'
import defaults from '../components/utils/PropDefaults.js'
import IMPlaceSearch from '../components/utils/IMPlaceSearch.vue'
import IMUserSearch from '../components/utils/UserSearch.vue'
import IMPhotoItem from '../components/items/PhotoCard.vue'
import IMPhotoModal from '../components/items/PhotoModal.vue'
import IMSortField from '../components/utils/IMSortField.vue'

export default {

    name: `Photos`,

    components: {
        'im-sort-filed': IMSortField,
        'im-place-search': IMPlaceSearch,
        'im-user-search': IMUserSearch,
        'im-photo-item': IMPhotoItem,
        'im-photo-modal': IMPhotoModal
    },

    data() {
        return {

            // dialogs
            add_dialog: false,
            delete_dialog: false,
            dialog_photo: false,
            dialog_mobile_sort: false,
            loading_delete: false,
            filter_location_id: null,
            filter_section_id: null,
            filter_section_ids: [],
            // sort
            im_header: [
                {
                    text: "Order",
                    sortable: true,
                    sort_dir: null,
                    sort_order: "order",
                    align: "left",
          }, {
                    text: "Title",
                    sortable: true,
                    sort_dir: null,
                    sort_order: "title",
                    align: "left",
          }, {
                    text: "Rating",
                    sortable: true,
                    sort_dir: null,
                    sort_order: "rating_avg",
                    align: "left",
          },
        ],
            // search
            search: null,
            search_timeout: 300,
            search_fields: [
                {
                    text: 'Id',
                    value: 'id',
                    selected: false
          }, {
                    text: 'Author',
                    value: 'author',
                    selected: false
          }, {
                    text: 'Description',
                    value: 'description',
                    selected: false
          }, {
                    text: 'Title',
                    value: 'title',
                    selected: false
          }, {
                    text: 'File name',
                    value: 'url',
                    selected: false
          },
        ],

            search_ids: null,
            search_place_ids: null,
            search_section_ids: null,
            filter_user_ids: null,
            search_order: [],

            // table items
            items: [],
            images: [],
            current_photo: defaults.photo_item,

            //
            photo: {
                place_id: null,
                section_id: null,
                title: null,
                description: null,
                order: 50
            },

            selected_file: null,

            // filter
            // section filter
            section: {},
            selected_section: {},
            sections: [],
            status: null,
            status_items: [
                {
                    text: "Approved",
                    value: "approved"
          }, {
                    text: "Pending",
                    value: "pending"
          }, {
                    text: "Rejected",
                    value: "rejected"
          }
        ],

            // table attributes
            loading: null,
            is_saving: null,
            pagination: null,
            rppi: [25, 50, 100],
            total: 0,
            page: 1,
            size: 25,
            itemsPerPageOptions: [25, 50, 100],

        }
    },

    watch: {

        page: {
            handler() {
                this.getItems()
            }
        },
        size: {
            handler() {
                this.getItems()
            }
        },

        search: {
            handler() {
                this.page = 1;
                clearTimeout(this.search_timeout);
                this.search_timeout = setTimeout(this.getItems, 500)
            }
        },

    },

    created() {
        this.getItems()
        this.getSections();
    },

    methods: {
        ...mapActions('alert', ['success', 'error']),

        openCreate() {
            this.add_dialog = true;
            this.images = [];
            this.$refs.place.reset();
            this.photo = {
                place_id: null,
                section_id: null,
                title: null,
                description: null,
                order: 50
            };
        },

        onFileChanged(event) {
            const files = event.target.files || event.dataTransfer.files;
            if(!files.length) {
                return;
            }

            Array.prototype.forEach.call(files, (file) => {
                this.createImage(file);
            });
        },

        createImage(file) {
            const fileReader = new FileReader();
            fileReader.onload = (event) => {
                this.images.push(event.target.result);
            };
            fileReader.readAsDataURL(file);
        },

        getSections() {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/destinations/sections';

            // prepare params
            let options = {
                params: {
                    size: 50
                }
            };

            // make places search request
            this.$axios.get(endpoint, options)
                .then(response => {
                    this.sections = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });

        },

        getItems() {
            // we are currently loading
            this.loading = true;

            // prepare filter for section
            if(!this.filter_section_id) {
                this.filter_section_ids = [];
            } else {
                this.filter_section_ids = [this.filter_section_id];
            }

            //prepare sorting & direction params
            let orders = [];
            let dirs = [];
            if(this.sort_field_item) {
                dirs.push(this.sort_field_dir);
                orders.push(this.sort_field_item);
            } else {
                dirs.push('desc');
                orders.push('order');
            }

            // prepare search string
            let search = this.search;
            if(search === '' || search === undefined) {
                search = null;
            }
            // prepare type search filter
            let fields = [];
            this.search_fields.forEach(field => {
                if(field.selected) {
                    fields.push(field.value);
                }
            });


            // prepare stamp & save current_stamp
            let stamp = Date.now();
            this.current_stamp = stamp;

            // setup query params
            let params = {
                params: {
                    search: search,
                    //ids: ids,
                    section_ids: this.filter_section_ids,
                    place_ids: this.filter_location_id,
                    user_ids: this.filter_user_ids,
                    fields: fields,
                    size: this.size,
                    page: this.page,
                    orders: orders,
                    dirs: dirs,
                    stamp: stamp,
                    // operational fields
                    status: this.status
                }
            };

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/destinations/photos';

            this.$axios.get(endpoint, params)
                .then(response => {
                    if(parseInt(this.current_stamp) === parseInt(response.data.meta.stamp)) {
                        this.items = response.data.data;
                        this.total = response.data.pagination.total;
                    }
                })
                .catch(error => {
                    console.log(error);
                    this.error('Oops, something went wrong!');
                })
                .finally(() => {
                    this.loading = false;
                })
        },

        savePhoto() {
            this.is_saving = true;
            let article_id_check = Number.isInteger(this.photo.article_id);
            let place_id_check = typeof this.photo.place_id === 'string';
            if(!article_id_check && !place_id_check) {
                this.add_dialog = false;
                this.dialog_photo = false;
                this.is_saving = false;
                this.error('Oops, something went wrong!');
                return
            }
            if(!article_id_check) {
                delete this.photo.article_id;
            }
            if(!place_id_check) {
                delete this.photo.place_id;
            }

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/destinations/photos';

            // call update or save endpoints
            if(this.photo.id) {
                this.$axios.put(endpoint + '/' + this.photo.id, this.photo) // eslint-disable-next-line
                    .then(() => {
                        this.success('Photo updated.');
                        this.getItems();
                        this.add_dialog = false;
                        this.dialog_photo = false;
                    })
                    .catch(error => {
                        console.error(error);
                        this.error('Oops, something went wrong!');
                    })
                    .finally(() => {
                        this.is_saving = false;
                    });

            } else {
                this.photo.photo = this.images[0];
                this.$axios.post(endpoint, this.photo) // eslint-disable-next-line
                    .then(() => {
                        this.success('Photo created.');
                        this.getItems();
                        this.dialog_photo = false;
                        this.add_dialog = false;
                    })
                    .catch(error => {
                        console.log(error);
                        this.error('Oops, something went wrong!');
                    })
                    .finally(() => {
                        this.is_saving = false;
                    });

            }
        },

        destroy() {
            this.loading_delete = true;
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/destinations/photos';

            // call delete endpoint

            this.$axios.delete(endpoint + '/' + this.current_photo.id) // eslint-disable-next-line
                .then(() => {
                    this.getItems();
                    this.success('Photo deleted.');
                    this.delete_dialog = false;
                    this.current_photo = null;
                })
                .catch(error => {
                    console.error(error);
                    this.error('Oops, something went wrong!');
                })
                .finally(() => {
                    this.loading_delete = false;
                });
        },
        openDeleteModal() {
            this.dialog_photo = false;
            this.delete_dialog = true;
        },
        selectPlace(place) {
            this.photo.place_id = place.id;
        },

        selectSection(section) {
            this.photo.section_id = section.id;
        },

        openEdit(photo) {
            this.add_dialog = true;
            this.photo = Object.assign({}, photo)
        },

        openDelete(photo) {
            this.delete_dialog = true;
            this.delete_photo = Object.assign({}, photo);
        },

        filterLocation(location) {
            if(location) {
                this.filter_location_id = [location.id];
            } else {
                this.filter_location_id = [];
            }
            this.filterItems();
        },

        filterSection(section) {
            if(section) {
                this.filter_section_ids = [section.id];
            } else {
                this.filter_section_ids = null
            }
            this.filterItems();
        },


        filterUser(user) {
            if(user) {
                this.filter_user_ids = [user.user_id];
            } else {
                this.filter_user_ids = null
            }
            this.filterItems();
        },

        filterItems() {
            this.page = 1;
            this.getItems();
        },

        seeItem(current_item) {
            this.current_photo = current_item;
            this.dialog_photo = true;
        },

        selectField(field) {
            field.selected = !field.selected;
            if(this.search) {
                this.getItems();
            }
        },

        sortField(sortItem) {
            this.sort_field_item = sortItem.sort_order;
            this.sort_field_dir = sortItem.sort_dir;
            this.getItems();
            this.dialog_mobile_sort = false;
        },
    }

}
</script>

<style>
.im-photogallery.v-data-iterator>div:first-child {
    color: black;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
}


.input-file {
    opacity: 0;
    /* invisible but it's there! */
    top: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    cursor: pointer;
}

@media (max-width: 991px) {
    .my-expansion-container {
        height: auto !important;
    }
}
</style>
